var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInventoryIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_554_2754)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4921 6.66699L12.9921 4.16699L11.4921 1.66699H8.50879L7.00879 4.16699L8.50879 6.66699H11.4921Z",
    fill: "#E8EAED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.50879 7.5L7.00879 10L8.50879 12.5H11.4921L12.9921 10L11.4921 7.5H8.50879Z",
    fill: "#E8EAED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.709 9.5918H16.7007L18.1923 7.0918L16.7007 4.5918H13.709L12.209 7.0918L13.709 9.5918Z",
    fill: "#E8EAED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7007 10.4258H13.709L12.209 12.9258L13.709 15.4258H16.7007L18.1923 12.9258L16.7007 10.4258Z",
    fill: "#E8EAED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.29193 9.5918L7.79193 7.0918L6.29193 4.5918H3.30026L1.80859 7.0918L3.30026 9.5918H6.29193Z",
    fill: "#E8EAED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.29193 10.4258H3.30026L1.80859 12.9258L3.30026 15.4258H6.29193L7.79193 12.9258L6.29193 10.4258Z",
    fill: "#E8EAED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.50879 13.334L7.00879 15.834L8.50879 18.334H11.4921L12.9921 15.834L11.4921 13.334H8.50879Z",
    fill: "#E8EAED"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_554_2754"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventoryIcon);
export default __webpack_public_path__ + "static/media/inventory-icon.9a5d58294bee80d2d64d5eb955a7aa27.svg";
export { ForwardRef as ReactComponent };